/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Bodyfat_TitleInputs */

const en_us2_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is your body fat percentage?`)
};

const pt_br2_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o seu percentual de gordura?`)
};

const es_419_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es tu porcentaje de grasa corporal?`)
};

const pt_pt2_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a tua percentagem de gordura?`)
};

const fr_fr2_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est ton pourcentage de masse grasse ?`)
};

const de_de2_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hoch ist dein Körperfettanteil?`)
};

const it_it2_profile_editors_bodyfat_title = /** @type {(inputs: Profile_Editors_Bodyfat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la tua percentuale di grasso?`)
};

/**
* | output |
* | --- |
* | "What is your body fat percentage?" |
*
* @param {Profile_Editors_Bodyfat_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_bodyfat_title = /** @type {((inputs?: Profile_Editors_Bodyfat_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Bodyfat_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_bodyfat_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_bodyfat_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_bodyfat_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_bodyfat_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_bodyfat_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_bodyfat_title(inputs)
	return en_us2_profile_editors_bodyfat_title(inputs)
});
export { profile_editors_bodyfat_title as "profile-editors.bodyfat_title" }